module.exports = __webpack_public_path__ + "img/NSeer64_ua.e8890660.webp";